import React from 'react';

const FooterLink = ({ locale, color }) => {
  return (
    <span
      style={{
        fontSize: '16px',
        marginBottom: '0px',
        marginTop: 'auto'
      }}
    >
      {locale.result.footer_link}{' '}
      <a
        style={{ cursor: 'pointer', color: color || '#fff' }}
        href={'https://healthcare.ascension.org/Specialty-Care/Coronavirus'}
      >
        Ascension.org
      </a>
      .
    </span>
  );
};

export default FooterLink;
